// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_O-z","hovered":"aP-z","hoverImage":"bP-z","mainImage":"cP-z","imageNoBackground":"dP-z","fullSizeImage":"eP-z"};